import React from 'react';
import type { TicketWidgetData } from '../../types/widgets';
import { SupportTicketCard } from '../../../components/ConciergeMessagePart/SupportTicketCard';

export interface TicketCardWidgetProps {
  data: TicketWidgetData;
}

/**
 * Top-half wrapper for the existing `<SupportTicketCard>`.
 * Handles stage spacing, max-width, and a priority badge above the card.
 * Does not re-implement ticket field rendering — that stays in SupportTicketCard.
 */
export const TicketCardWidget: React.FC<TicketCardWidgetProps> = ({ data }) => {
  const { ticketId, displayId, status, sla, priority, ticketUrl, message, nextSteps } = data;

  return (
    <div
      style={{
        width: '100%',
        maxWidth: 420,
        padding: '4px 0',
        boxSizing: 'border-box',
      }}
    >
      {/* Priority badge */}
      {priority === 'high' && (
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 5,
            fontSize: 11,
            fontWeight: 700,
            letterSpacing: 0.4,
            textTransform: 'uppercase',
            color: 'var(--voice-widget-warn, #DC2626)',
            background: 'var(--voice-widget-warn-bg, #FEF2F2)',
            border: '1px solid var(--voice-widget-warn-border, #FECACA)',
            padding: '3px 10px',
            borderRadius: 999,
            marginBottom: 8,
          }}
        >
          <span>●</span> High priority
        </div>
      )}

      {/* SLA line */}
      <div
        style={{
          fontSize: 12,
          color: 'var(--voice-widget-muted, #6B7280)',
          marginBottom: 6,
        }}
      >
        Response within <strong style={{ color: 'var(--voice-widget-fg, #111827)' }}>{sla}</strong>
      </div>

      {/* Existing ticket card — re-used unchanged */}
      <SupportTicketCard
        status="success"
        message={message ?? ''}
        ticketId={ticketId}
        displayId={displayId}
        ticketUrl={ticketUrl}
        ticketState={status}
        nextSteps={nextSteps}
      />
    </div>
  );
};

export default TicketCardWidget;
